<template>
    <div class="background">
        <HeaderHome :user="this.$store.state.user.prenom"/>
        <div class="greeting">
          <h1>Liste des examens</h1>
          <p>Consulter la liste de vos examens futurs et passés</p>
        </div>
        <div class="tableau-exam">
          <button class="btn btn-primary" @click="getExamsMono('old')" v-if="!showOldExam">VOIR ANCIEN EXAM</button>
          <button class="btn btn-danger" @click="getExamsMono('recent')" v-else>VOIR EXAM A VENIR</button>
          <br>
          <template v-if="examSelec === ''">
              <DataTable v-model:selection="examSelec" :value="exams" paginator :rows="5" selectionMode="single" :rowsPerPageOptions="[5, 10, 20, 50]">
                  <Column field="date" header="Date"></Column>
                  <Column field="heure" header="Heure"></Column>
                  <Column field="lieu" header="Lieu"></Column>
                  <Column field="boite" header="Boite"></Column>
              </DataTable>
          </template>
          <template v-else>
            <div class="exam-info">
              <p>Examen <b>{{ examSelec.boite }}</b></p>
              <p>Le <b>{{ examSelec.date }}</b> de <b>{{ examSelec.heure }}</b></p>
              <p>RDV à <b>{{ examSelec.lieu }}</b></p>
              <button class="btn btn-danger" @click="examSelec = '';">X</button>
            </div>
            
              <DataTable :value="examSelec.eleves" paginator :rows="5" :rowsPerPageOptions="[5, 10, 20, 50]">
                  <Column field="nom" header="Nom"></Column>
                  <Column field="prenom" header="Prenom"></Column>
              </DataTable>
          </template>
        </div>

    </div>
  </template>
  
  <script>

  import HeaderHome from "../../components/home/HeaderHome.vue";
  
  export default {
  
      props: [

      ],
  
    components: {
      HeaderHome
    },
  
    watch: {},
  
    data() {
      return {
        examSelec : "",
        exams : [],
        showOldExam : "recent",
      };
    },
  
    mounted() {
      this.getExamsMono("recent");
    },
  
    methods: {
      getExamsMono(old){

        if(old === "old"){
          this.showOldExam = true;
        }else{
          this.showOldExam = false;
        }

        window.api
          .get(
            "/exams/moniteurs/" + this.$store.state.user.idMono + "/" + old,
            {
              headers: {
                Authorization: "Bearer " + this.$store.state.token,
              },
            }
          )
          .then((response) => {
            this.exams = response.data.exams;
          })
          .catch((error) => {
            console.log(error);
          });
      },
    }
  };
  </script>
  
  <style scoped>
  
  div.background {
        background-color: #F4F6F9;
        min-height: 100vh;
        padding-bottom: 1rem;
  }

/* DATATABLE STYLE */

/* Table wrapper */
:deep(.p-datatable) {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  overflow: hidden;
  font-size: 14px;
}

/* Header */
:deep(.p-datatable .p-datatable-thead > tr > th) {
  background: #ffffff;
  color: #9ca3af;
  font-weight: 500;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  padding: 14px 20px;
  border-bottom: 1px solid #f3f4f6;
  border-right: none;
}

/* Rows */
:deep(.p-datatable .p-datatable-tbody > tr) {
  background: #ffffff;
  transition: background 0.15s;
}

:deep(.p-datatable .p-datatable-tbody > tr:hover) {
  background: #f9fafb;
}

:deep(.p-datatable .p-datatable-tbody > tr > td) {
  padding: 18px 20px;
  border-bottom: 1px solid #f3f4f6;
  border-right: none;
  color: #111827;
  font-size: 14px;
}

/* Nom en gras */
:deep(.p-datatable .p-datatable-tbody > tr > td:nth-child(2)) {
  font-weight: 600;
}

/* Suppression du style de sélection par défaut */
:deep(.p-datatable .p-datatable-tbody > tr.p-highlight) {
  background: #f0f9ff;
}


/* Paginator */
:deep(.p-paginator) {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-top: none;
  border-radius: 0 0 12px 12px;
  padding: 10px 16px;
}

:deep(.p-paginator .p-paginator-page.p-highlight) {
  background: #3b82f6;
  color: #ffffff;
  border-radius: 8px;
  border-color: #3b82f6;
}

:deep(.p-paginator .p-paginator-page),
:deep(.p-paginator .p-paginator-prev),
:deep(.p-paginator .p-paginator-next),
:deep(.p-paginator .p-paginator-first),
:deep(.p-paginator .p-paginator-last) {
  color: #6b7280;
  border: none;
  min-width: 32px;
  height: 32px;
  border-radius: 8px;
}

:deep(.p-paginator .p-paginator-page:hover:not(.p-highlight)),
:deep(.p-paginator .p-paginator-prev:hover),
:deep(.p-paginator .p-paginator-next:hover) {
  background: #f3f4f6;
}

div.greeting{
  width: 95%;
  margin: auto;
  text-align: left;
  margin-top: 1rem;
}

div.greeting h1{
  margin: 0;
  font-weight: bold;
}

div.greeting p{
  color: #666666;
}

div.tableau-exam{
  width: 95%;
  margin: auto;
  margin-top: 1rem;
}

div.tableau-exam button{
  margin-bottom: 1rem;
}

div.exam-info{
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: white;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 1rem;
}




  </style>
  